import { MainBannerHero } from "@/api/generated/BMWInterfaces"
import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  align-items: center;
  flex: 1 0 0;
  justify-content: center;
  margin-top: 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 64px;
    margin-top: 0;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  text-align: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    flex: 1 0 0;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  text-align: center;
  gap: 4px;
  min-height: 98px;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: flex-start;
  ${(props) => props.theme.breakpoints.down("md")} {
    min-height: 103px;
  }
`

const StyledLogoContainer = styled.div`
  height: 48px;
  width: 148px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 64px;
    width: 200px;
  }
`

type Props = {
  story: MainBannerHero
}

export default function HeroContent({ story }: Props): React.ReactElement {
  const currentStory = story
  return (
    <StyledContent>
      <ContentBox>
        <StyledLogoContainer>
          {currentStory.logo && (
            <>
              <Desktop>
                <Image
                  src={currentStory.logo.imageUrl}
                  alt={currentStory.logo.alt || ""}
                  width={200}
                  height={64}
                  style={{ objectFit: "contain" }}
                  priority
                />
              </Desktop>
              <Mobile>
                <Image
                  src={currentStory.logo.imageUrl}
                  alt={currentStory.logo.alt || ""}
                  width={148}
                  height={48}
                  style={{ objectFit: "contain" }}
                  priority
                />
              </Mobile>
            </>
          )}
        </StyledLogoContainer>
        <TextBox>
          {currentStory.title && (
            <>
              <Mobile>
                <Typography variant="h2" component={"h2"} color={"white"}>
                  {currentStory.title}
                </Typography>
              </Mobile>
              <Desktop>
                <Typography variant="h1" component={"h2"} color={"white"} lineHeight={"59px"}>
                  {currentStory.title}
                </Typography>
              </Desktop>
            </>
          )}
          {currentStory.subTitle && (
            <>
              <Mobile>
                <Typography variant="body1" component={"p"} color={"white"}>
                  {currentStory.subTitle}
                </Typography>
              </Mobile>
              <Desktop>
                <Typography variant="h3" component={"p"} color={"white"}>
                  {currentStory.subTitle}
                </Typography>
              </Desktop>
            </>
          )}
        </TextBox>
      </ContentBox>
    </StyledContent>
  )
}
